<script setup>
import { ref, inject, watchEffect, onMounted } from 'vue'
import { useAlternativeShopStore } from '@/stores/AlternativeShopStore'
import { useCartStore } from '@/stores/CartStore'
import { useRoute, useRouter } from 'vue-router'
import { useCommon } from '@/hooks/useCommon'
import ShareBar from '@/components/ShareBar.vue'

const siteConfig = inject('siteConfig')
const shopStore = useAlternativeShopStore()
const cartStore = useCartStore()
const { getImageUrl } = useCommon()

const route = useRoute()
const router = useRouter()


const qty = ref(1)
const selectedImage = ref(null)
const productInCart = ref(false)
let shopItem = ref(null)

const checkProductInCart = () => {
  productInCart.value = cartStore.itemQty('inventory', route.params.id) > 0
}

const addToCart = async () => {
  productInCart.value = true

  await cartStore.addShopItem(shopItem.value, qty.value)

  setTimeout(() => {
    cartStore.toggleCart(true)
  }, 50)
}


const goBack = () => {
  if (route.query?.backTo) {
    router.push({ path: route.query.backTo })
  } else if (
    window?.history?.state?.back?.includes('/shop')
  ) {
    // TODO: the filters are being dropped from the url before the back button is clicked
    window.history.back()
  } else {
    router.push({ path: '/shop/products' })
  }
}

watchEffect(() => {
  checkProductInCart()
  if (shopItem.value?.images) {
    selectedImage.value = shopItem.value?.images[0]
  }
  qty.value = cartStore.itemQty('inventory', route.params.id) || 1
})

onMounted(async () => {
  checkProductInCart()
  shopItem.value = await shopStore.productById(route.params.id);
})

</script>

<template>
  <div class="">
    <div v-if="!shopItem" class="flex flex-col items-center justify-center h-full gap-4">
      No product found
      <button @click="goBack" class="go-back-link btn-accent-1 small-bold">
        <Icon icon="heroicons-outline:chevron-left" class="icon" />
        Go Back
      </button>
    </div>
    
    <section v-if="shopItem" class="product-details pb-4 md:pb-7 lg:pb-10">
      <ShareBar/>
      <button @click="goBack" class="go-back-link btn-accent-1 small-bold">
        <Icon icon="heroicons-outline:chevron-left" class="icon" />
        Go Back
      </button>
      <div class="product-box">
        <div class="images-wrapper">
          <div class="main-image">
            <img v-if="selectedImage" :src="selectedImage" class="!object-contain object-top"/>
            <img v-else :src="`/sites/${siteConfig.key}/logo.jpg`" class="!object-contain object-top" />
            <!-- <div class="image-overlay">
              <h5 class="xlarge-text xl:heading-3 -mb-1">
                {{ shopItem.categoryName }}
              </h5>
              <span>{{ shopItem.itemType }}</span>
            </div> -->
          </div>

          <div class="alt-images" v-if="shopItem.images?.length > 1">
            <button
              v-for="image in shopItem.images"
              :key="image"
              :class="{ selected: selectedImage === image }"
              @click="selectedImage = image"
            >
              <img :src="image" />
            </button>
          </div>
        </div>

        <div class="product-info">
          <h3 class="text-secondary-text xlarge-text">
            {{ shopItem.artistFirstName }}
            {{ shopItem.artistLastName }}
          </h3>
          <h1 class="product-name heading-3 xl:heading-1">
            {{ shopItem.itemName }}
          </h1>
          <h4 class="product-dimensions text-secondary-text large-regular capitalize">
            {{ shopItem.itemType  }}
            {{ shopItem.itemType && shopItem.dimensions ? ' - ' + shopItem.dimensions : '' }}
            {{ ((shopItem.dimensions || shopItem.itemType) && shopItem.medium && shopItem.medium.toLowerCase() !== 'none') ? ' - ' + shopItem.medium : '' }}
          </h4>
          <h2 class="product-price heading-3 xl:heading-2">
            ${{ shopItem.price.toFixed(2) }}
          </h2>
          <p v-if="shopItem.itemCode">SKU#: {{ shopItem.itemCode }}</p>
          <p class="product-description">{{ shopItem.itemDescr }}</p>
          <!-- <div class="product-colors box">
            <h3>Colors:</h3>
            <ul>
              <li v-for="color in product.colors" :key="color" :class="{selected: product.selectedColor.hex === color.hex}">
                <button :style="{backgroundColor: color.hex}" @click="selectProductColor(color)"></button>
              </li>
            </ul>
          </div> -->
          <!-- <RadioGroup
            v-model="product.selectedColor"
            class="product-colors box"
          >
            <RadioGroupLabel as="h3">Colors:</RadioGroupLabel>
            <ul>
              <RadioGroupOption
                v-for="color in product.colors"
                :value="color"
                v-slot="{ checked }"
                as="template"
              >
                <li
                  :class="{
                    selected:
                      checked || color.hex === product.selectedColor.hex,
                  }"
                >
                  <button :style="{ backgroundColor: color.hex }"></button>
                </li>
              </RadioGroupOption>
            </ul>
          </RadioGroup> -->
          <!-- <div class="product-sizes box"> -->
          <!-- <h3>Size:</h3> -->
          <!-- <BaseDropdown
              :dropdown="product.sizesList"
              class="box-drop gray-bg"
            /> -->
          <!-- <Listbox
              v-model="product.sizesList.selectedItem"
              @update:modelValue="updateProductSize"
              v-slot="{ open }"
              class="base-listbox"
              as="div"
            >
              <div class="listbox-overlay" v-if="open"></div>
              <div class="relative">
                <ListboxButton
                  class="listbox-button !w-64"
                  :class="{
                    'filter-selected':
                      product.sizesList.selectedItem !== 'Select a size',
                  }"
                >
                  <span class="block truncate">{{
                    product.sizesList.selectedItem ||
                    product.sizesList.options[0]
                  }}</span>
                  <span class="selector-icon">
                    <Icon
                      icon="heroicons-outline:selector"
                      class="h-5 w-5 text-secondary-text"
                    />
                  </span>
                </ListboxButton>
                <transition name="fade-fast">
                  <ListboxOptions class="listbox-options" static v-show="open">
                    <ListboxOption
                      v-slot="{ active }"
                      v-for="option in product.sizesList.options"
                      :value="option"
                      as="template"
                    >
                      <li
                        class="listbox-option small-regular"
                        :class="[
                          { 'bg-gray-50': active },
                          {
                            'font-bold text-accent-1':
                              product.sizesList.selectedItem === option,
                          },
                        ]"
                        v-html="option"
                      ></li>
                    </ListboxOption>
                  </ListboxOptions>
                </transition>
              </div>
            </Listbox> -->
          <!-- </div> -->
          <div class="product-qty box">
            <h3>Qty:</h3>
            <input type="number" class="form-control" placeholder="0" v-model="qty" :max="shopItem.quantity" :min="0" />
            <span class="small-regular" :class="{'text-accent-2': shopItem.quantity < qty, 'text-secondary-text': shopItem.quantity >= qty}">{{ shopItem.quantity }} available</span>
          </div>

          <button
            v-if="shopItem.quantity > 0"
            class="btn-accent-1 btn-cart xl:large-regular"
            @click="addToCart"
          >
            {{ productInCart ? 'Update Cart' : 'Add To Cart' }}
          </button>
          <span v-else class="text-accent-2">
            Out of Stock
          </span>
        </div>
      </div>

      <!-- <div class="about-product detailed-inforamtion">
        <h2 class="xlarge-text lg:heading-3 mb-2.5 lg:mb-3.5">
          Product Details
        </h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea odit,
          placeat perspiciatis, temporibus ipsam repudiandae modi minus eveniet
          adipisci voluptate, nesciunt dolorem. Quas molestias repellat
          perferendis nulla hic vel beatae blanditiis sed? Sint nemo adipisci
          in! Tenetur, praesentium? Impedit minus rem id temporibus qui dolores
          quaerat, quasi debitis. Facilis nam sequi aspernatur saepe quaerat eos
          nemo ut quis enim vel, sapiente libero dolorem? Nobis totam quia earum
          porro placeat et ut libero quidem, ducimus fugit corrupti voluptatem
          nostrum voluptate necessitatibus architecto rerum. Culpa minus autem
          id libero eius doloremque cumque eveniet eos nobis nam pariatur,
          voluptatibus ipsam ex sequi. Amet.
        </p>
      </div> -->

      <footer
        class="flex flex-col sm:flex-row items-stretch justify-between mt-[200px] gap-4"
      >
<!--        <router-link-->
<!--          :to="`/shop/shop-by-artist/${shopItem.artistId}`"-->
<!--          class="outlined-accent-1 py-2 px-5 text-center"-->
<!--        >-->
<!--          More from {{ shopItem.artistFirstName }}-->
<!--          {{ shopItem.artistLastName }}-->
<!--        </router-link>-->
        <router-link
          :to="'/shop/products'"
          class="btn-accent-1 py-2 px-5 text-center"
        >
          Shop All Items
        </router-link>
      </footer>
    </section>
  </div>

  <div class="clear-both"></div>
</template>

<style lang="postcss">
.product-details {
  .product-box {
    @apply flex flex-col md:flex-row gap-y-6 gap-x-3 md:gap-x-5 xl:gap-x-7 mb-5 md:mb-7 lg:mb-10;
    .images-wrapper {
      .main-image {
        @apply relative;
        img {
          @apply md:w-56 lg:w-72 xl:w-[23rem] md:h-56 lg:h-72 xl:h-[23rem] object-cover aspect-square;
        }
        .image-overlay {
          @apply absolute bottom-0 left-0 bg-black/75 text-white
          pt-1.5 pb-2.5 px-5 xl:px-[1.15rem] text-center;
        }
      }
      .alt-images {
        @apply flex items-center justify-center gap-x-3 mt-3;
        button {
          @apply rounded overflow-hidden border border-transparent transition flex-1 md:flex-none;
          &.selected {
            @apply border-accent-1;
          }
          img {
            @apply md:w-[68px] lg:w-20 md:h-[68px] lg:h-20 aspect-square;
          }
        }
      }
    }
    .product-info {
      @apply relative flex-1;
      .product-name {
        @apply mb-2 lg:mb-5;
      }
      .product-dimensions {
        @apply mb-2 lg:mb-5
      }
      .product-price {
        @apply mb-2 lg:mb-5 text-accent-2;
      }
      .product-description {
        @apply pb-3.5 lg:pb-5 border-b border-gray-300 mb-3.5 lg:mb-5;
      }
      .box {
        @apply flex items-center gap-x-3 mb-3.5 lg:mb-5;
        h3 {
          @apply font-bold;
        }
      }
      .product-colors ul {
        @apply flex items-center gap-x-1;
        li {
          @apply w-9 h-9 rounded-full border border-transparent inline-flex items-center justify-center transition;
          &.selected {
            @apply border-gray-200;
          }
          button {
            @apply inline-block w-6 h-6 rounded-full;
          }
        }
      }
      .product-sizes .box-drop {
        @apply w-64;
      }
      .product-qty .form-control {
        @apply px-2 w-12 text-center;
      }
      .btn-cart {
        @apply inline-block py-2.5 px-[3.6rem] w-full md:w-auto text-center mt-2 xl:mt-3;
      }
    }
  }

  @screen xl {
    .product-box .images-wrapper {
      @apply h-0 md:w-56 lg:w-72 xl:w-[23rem];
    }
    .detailed-inforamtion {
      @apply ml-auto w-[calc(100%-31.75rem)] mb-10;
    }
  }
}
</style>
